/* tslint:disable:object-shorthand-properties-first */
import Fetch from '@App/helpers/fetch'
import awaitToJs from 'await-to-js'
import * as base64 from 'base-64'
import * as cookie from 'js-cookie'
import { setAlertBox } from './snackbar'
import {
  SET_LOGIN_USER,
  COOKIES_AUTHORIZATION_TOKEN,
  MESSAGE_ERROR,
  ALERT_COLORS,
  COOKIES_BLIINK_USERS,
  SET_REDIRECT,
  COOKIE_DOMAIN,
  LOGIN_ROUTE,
  ALERT_DELAY,
} from '@App/constantes'

import { API_URL } from '@App/configs/rest'
import history from '@App/helpers/history'

const COOKIE_EXP = 3600 * 3
const fetchSignInUser = new Fetch()

export const setSignInUser = (user: Object) => {
  return {
    type: SET_LOGIN_USER,
    payload: user,
  }
}

export const getRedirect = (redirect: string) => {
  return {
    type: SET_REDIRECT,
    payload: redirect,
  }
}

export const getSignInUser = ({ email, password }: { email: string, password: string }) => {
  return async (dispatch: Function, getState: any) => {
    const [err, data] = await awaitToJs(fetchSignInUser.get({
      url: `${API_URL}/users/auth/login`,
      params: null,
      headers: {
        Authorization: `Basic ${base64.encode(`${email}:${password}`)}`,
      },
    }))

    if (!err && data) {
      cookie.set(COOKIES_AUTHORIZATION_TOKEN, data.token, { expires: COOKIE_EXP, domain: COOKIE_DOMAIN })
      window.localStorage.setItem(COOKIES_BLIINK_USERS, JSON.stringify(data.user))

      dispatch(setSignInUser(Object.assign({}, data.user)))

      return data
    }

    if (err) {

      dispatch(setAlertBox({
        title: err && err.message || MESSAGE_ERROR,
        background: ALERT_COLORS.red,
        delay: ALERT_DELAY,
      }))

      return err
    }
  }
}

export const logoutUser = () => {
  window.localStorage.removeItem('persist:root')
  cookie.remove(COOKIES_AUTHORIZATION_TOKEN, { domain: COOKIE_DOMAIN })
  window.localStorage.removeItem(COOKIES_BLIINK_USERS)
  history.push(LOGIN_ROUTE)
}
